<template>
    <div style="background: #FAFAFA;">
        <div class="container"  style="padding-bottom: 40px; padding-top: 0.5rem">
            <h3>Upload Challenge</h3>
            <div class="upload-box">
                <input
                    type="file"
                    ref="fileInput"
                    multiple
                    @change="handleFiles"
                    hidden
                />

                <div class="row">
                    <!-- File previews -->
                    <div
                        class="col-6 col-lg-4 mb-3"
                        v-for="(file, index) in files"
                        :key="index"
                    >
                        <svg class="border-svg container" v-if="uploading">
                            <rect x="0" y="0" width="100%" height="100%" rx="10" ry="10" />
                        </svg>
                        <div class="file-card preview-card">

                        <!-- Image -->
                        
                        <img
                            v-if="file.type.startsWith('image')"
                            :src="file.preview"
                        />

                        <!-- PDF -->
                        <div v-else-if="file.type.includes('pdf')" class="file-icon">
                            📄 PDF
                        </div>

                        <!-- Video -->
                        <video
                            v-else-if="file.type.startsWith('video')"
                            :src="file.preview"
                            controls
                            >
                        </video>


                        <!-- Other -->
                        <div v-else class="file-icon">
                            📎 {{ file.name }}
                        </div>

                        <button :disabled="uploading" class="remove-btn" @click="removeFile(index)">
                            ✕
                        </button>

                        </div>
                    </div>
                    <div class="col-6 col-lg-4 mb-4" >
                        <svg class="border-svg container" v-if="uploading">
                            <rect x="0" y="0" width="100%" height="100%" rx="10" ry="10" />
                        </svg>
                        <button :disabled="uploading" :class="{ 'is-loading': uploading }" class="btn upload-btn" @click="$refs.fileInput.click()">
                            <img src="../../assets/icons/file-upload.svg" alt="file">
                            <p v-if="!uploading">Upload Media</p>
                            <p v-if="uploading">Uploading Media, wait...</p>
                        </button>
                    </div>
                </div>
                <p class="upoad-instruction">You can upload upto four (4) media only</p>
                
            </div>

            <div clas="form-group">
                <label for="description">Description</label>
                <textarea v-model="description" class="form-control" col="" name="" id="description" placeholder="Write the challenge description"></textarea>
            </div>

            <div class="settings-card">
                <!-- Dynamic loop rendering each toggle matching the design -->
                <div 
                    v-for="(item, key) in settings" 
                    :key="key" 
                    class="toggle-row"
                >
                    <!-- Responsive Text Label -->
                    <span class="toggle-label">{{ item.label }}</span>
                    
                    <!-- Custom Accessible Switch -->
                    <button 
                    type="button" 
                    class="toggle-switch" 
                    :class="{ 'is-active': item.value === 'YES' }"
                    @click="item.value = (item.value === 'YES' ? 'NO' : 'YES')"
                    :aria-checked="(item.value === 'YES').toString()"
                    role="switch"
                    >
                    <span class="toggle-handle"></span>
                    </button>
                    <!-- Custom Accessible Switch -->
                    <!-- <button 
                    type="button" 
                    class="toggle-switch" 
                    :class="{ 'is-active': item.value }"
                    @click="item.value = !item.value" // Boolean
                    @click="item.value = (item.value === 'YES' ? 'NO' : 'YES')" //
                    :aria-checked="item.value.toString()"
                    role="switch"
                    >
                    <span class="toggle-handle"></span>
                    </button> -->


                    
                </div>
            </div>

            <div class="radio-options">
                <div class="form-group form-check">
                    <input v-model="protect" type="checkbox" class="form-check-input" id="protect" true-value="yes" false-value="no">
                    <label class="form-check-label" for="protect">
                        This project protects Shelta and its subsidiaries from legal concerns.
                    </label>
                </div>
            </div>


            <div class="vote-btn d-flex gap-2 ">
                <button class="btn vote-now" :disabled="loader || uploading" @click="submitUpload()">
                    {{ loader ? 'Please wait...' : 'Submit' }}
                    <i
                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                    v-if="loader"
                    ></i>
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "Uploads",
    components: {
        PageLoader
    },

    data() {
        return {
            loader: false,
            uploading: false,
            files: [],
            maxFiles: 4,
            maxSize: 8 * 1024 * 1024,
            filesToServer: [],
            protect: "",
            description: "",
            published: 'NO',
            settings: {
                canPublish: { label: 'Publish', value: 'NO' },
                // uploadEntries: { label: 'Upload Challenge Entries', value: true },
                // receiveUpdates: { label: 'Receive Updates', value: true },
                // manageParticipation: { label: 'Manage Participation', value: true }
            },
        };
    },
    watch: {
        settings: {
            deep: true,
            handler(newSettings) {
                // Formats a clean key-value payload: { viewProfile: "YES", uploadEntries: "NO", ... }
                const payload = Object.keys(newSettings).reduce((acc, key) => {
                acc[key] = newSettings[key].value;
                return acc;
                }, {});

                this.published = payload.canPublish;
                // console.log('Detected change! Sending payload:', this.published);
            }
        },
    },
    mounted() {
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        handleFiles(event) {
            const selectedFiles = Array.from(event.target.files);

            for (let file of selectedFiles) {

                if (this.files.length >= this.maxFiles) {
                // alert("Maximum 4 files allowed");
                    this.$store.commit("setApiFailed", "Maximum 4 files allowed");
                    break;
                }

                if (file.size > this.maxSize) {
                // alert(`${file.name} exceeds 4MB`);
                    this.$store.commit("setApiFailed", `${file.name} exceeds 8MB`);
                    continue;
                }

                const fileObj = {
                file: file,
                name: file.name,
                type: file.type,
                preview: file.type.startsWith("image")
                    ? URL.createObjectURL(file)
                    : null
                };

                this.files.push(fileObj);
                this.uploadFiles(file)
            }
            event.target.value = "";
        },
        async uploadFiles(file) {
            this.uploading = true;
            try {
                const formData = new FormData();
                formData.append("file", file);
                await Api.postRequest(`upload-super-kids-challenge-media`, formData)
                    .then(res => {
                        // console.log("file upload", res)
                        this.uploading = false;
                        if (res.data.error) {
                            // this.fileSizeType = true;
                            return this.$store.commit("setApiFailed", res.data.error);
                        } else if (res.data.success) {
                            this.uploading = false;
                            this.filesToServer.push(res.data.data);
                            // console.log('file array' , this.filesToServer);
                            // this.propertyImageUppload = true;
                            // this.propertyimages = res.data.filename;
                            // this.propimgname = res.data.filename;
                            this.$store.commit("setApiSuccess", "success");
                        }
                    })
                    .catch(err => {
                        console.log("err:", err)
                        this.uploading = false;
                    });
            } finally {
            // console.log("Closed connection");
            }
        },

        removeFile(index) {
            this.files.splice(index, 1);
            this.filesToServer.splice(index, 1);
        },
        submitUpload() {
            const activeKid = JSON.parse(localStorage.getItem('kidDetails'));
            if (this.filesToServer.length == 0) {
                return this.$store.commit("setApiFailed", "Select a fill to upload");
            }
            if (this.description == "") {
                return this.$store.commit("setApiFailed", "Enter description");
            }
            if (this.protect == "") {
                return this.$store.commit("setApiFailed", "Check the box please");
            }
            this.loader = true;
            try {
                Api.postRequest(`create-post-for-current-challenge`, 
                {
                    kid_id: activeKid.id,
                    write_up: this.description,
                    media: JSON.stringify(this.filesToServer), 
                    challenge_id: this.$route.params.id,
                    published: this.published,
                }).then(res => {
                    // console.log("Submitted", res);
                    this.loader = false;
                    if (res.data.success) {
                        this.$store.commit("setApiSuccess", "success");
                        this.$router
                            .push({
                            path: `/dashboard/superkid-dashboard`
                            })
                            .catch(() => {
                            // console.log("none")
                        });
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log("err:", err);
                    this.loader = false;
                })
            } finally {
                // console.log("closed")
            }
        }
    }
};

</script>


<style scoped lang="scss">
    .upload-btn {
        border: 1px dashed #A3A3A3;
        border-radius: 10px;
        padding: 12px;
        width: 100%;
        height: 200px;
        outline: 0;
        box-shadow: none;
    }

    h3 {
        font-family: Nunito;
        font-weight: 800;
        text-align: left;
        font-size: 25px;
        line-height: 28px;
        color: #1C2B3A;
        margin-top: 30px;
        margin-bottom: 30px;
    }


    .file-card {
        height: 201px;        /* standard height */
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }
    .upload-card {
        height: 201px;
        border: 2px dashed #ddd;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .preview-card {
        position: relative;
        height: 201px;
        border: 1px solid #ddd;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
    }

    .preview-card img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px;
    }
    .preview-card video {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px;
    }

    .file-icon {
        font-size: 14px;
        text-align: center;
    }

    .remove-btn {
        position: absolute;
        top: 4px;
        right: 4px;
        background: red;
        color: white;
        border: none;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        padding: 0;
    }

    .upoad-instruction {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #000000;
        text-align: left;
    }
    label {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #5D6F7C;
        display: flex;
        margin-top: 30px;
    }
    textarea {
        outline: 0 !important;
        box-shadow: none !important;
    }

    .radio-options {
        // border: 2px solid #F5F7FA;
        // padding: 20px;
        // border-radius: 12px;
        text-align: left;
        background: #ffffff;
    }

    input[type="checkbox"]:checked {
        border-width: 6px; /* "Ring" thickens when selected */
        border-color: #2EBFCA;
    }

    input[type="checkbox"] {
        appearance: none;
        -webkit-appearance: none;
        width: 20px;
        height: 20px;
        border: 2px solid #ccc; /* Unselected ring width */
        outline: none;
        cursor: pointer;
    }

    .form-check-label {
        margin-bottom: 0;
        // font-family: Lato;
        // font-weight: 500;
        // font-size: 16px;
        color: #5D6F7C;
        padding-left: 12px;
        padding-top: 2px;
    }

    .vote-btn {
        margin-top: 40px;
        .vote-now {
            background: #2AB3E6;
            color: #ffffff;
            border-radius: 8px;
            min-height: 38px;
            font-family: Lato;
            font-weight: 600;
            font-size: 18px;
            width: 100%;
            outline: 0;
            box-shadow: none;
        }
    }

    /* The Animated Border */
    .border-svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none; /* Allows clicking through to the box */
        }

        .border-svg rect {
            fill: none;
            stroke: #A3A3A3;      /* Your color */
            stroke-width: 2px;
            stroke-dasharray: 8, 4; /* Length of dash, length of gap */
            stroke-linecap: round;
            animation: dash-move 0.5s linear infinite;
        }

        @keyframes dash-move {
            to {
                stroke-dashoffset: -12; /* Matches the sum of dasharray (8+4) */
            }
        }

        .content {
            z-index: 2;
            color: #A3A3A3;
            font-family: Lato;
        }

        .loader-text {
            position: absolute;
            z-index: 3;
            font-size: 14px;
            color: #3498db;
        }

    // .upload-box {
    //     position: relative;
    //     width: 100%;
    //     height: 200px;
    //     padding: 12px;
    //     border-radius: 10px;
    //     background: transparent;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     overflow: hidden;
    // }

    // toggle btn starts
/* Card container mirroring the subtle off-white background tint */
.settings-card {
  background-color: #f6f7fb;
  border-radius: 24px;
  width: 100%;
  max-width: 560px; /* Adapts dynamically down to mobile widths */
  padding: 12px 0;
  box-sizing: border-box;
  margin-top: 30px;
}

/* Flexbox row layout */
.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  width: 100%;
  box-sizing: border-box;
  gap: 16px;
}

/* Typography styles */
.toggle-label {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 16px;
  color: #5c6470;
  font-weight: 400;
  user-select: none;
  max-width: 70%;
  word-wrap: break-word;
}

/* Outer Track Switch */
.toggle-switch {
  position: relative;
  width: 60px;
  height: 34px;
  background-color: #cbd5e1; /* Inactive track color */
  border-radius: 34px;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.25s ease;
  flex-shrink: 0; /* Keeps toggle perfectly round on narrow viewports */
  outline: none;
}

/* Active Track Color Matching Image */
.toggle-switch.is-active {
  background-color: #2AB3E6;
}

/* Sliding Handle Knob */
.toggle-handle {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 28px;
  height: 28px;
  background-color: #ffffff;
  border-radius: 50%;
  transition: transform 0.25s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

/* Shift Knob Right */
.toggle-switch.is-active .toggle-handle {
  transform: translateX(26px);
}

/* Focus Ring for Keyboard Users */
.toggle-switch:focus-visible {
  box-shadow: 0 0 0 3px rgba(90, 174, 227, 0.4);
}

/* Responsive Scaling Breakpoint */
@media (max-width: 360px) {
  .toggle-row {
    padding: 12px 16px;
  }
  .toggle-label {
    font-size: 14px;
  }
  .toggle-switch {
    width: 52px;
    height: 30px;
  }
  .toggle-handle {
    width: 24px;
    height: 24px;
  }
  .toggle-switch.is-active .toggle-handle {
    transform: translateX(22px);
  }
}

// Toggle Btn ends
</style>